import { render } from "./DashboardRegistriesClosed.vue?vue&type=template&id=30d39b80"
import script from "./DashboardRegistriesClosed.vue?vue&type=script&lang=js"
export * from "./DashboardRegistriesClosed.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__